import { Representative } from '../dtos/register-form/representative/representative';
import { InviteRepresentativeResponseDTO } from '../dtos/responses/invite-representative-response-dto/invite-representative-response-dto';

export type GeneralizedRepresentative =
  | Representative
  | InviteRepresentativeResponseDTO;

/**
 * If a GeneralizedRepresentative is a Representative or not
 * @param {GeneralizedRepresentative} generalizedRepresentative
 * @return {boolean}
 */
export function isRepresentative(
  generalizedRepresentative: GeneralizedRepresentative
): generalizedRepresentative is Representative {
  return (generalizedRepresentative as Representative).firstName !== undefined;
}
